function initProductListSlider() {
  const productListSlider = new Swiper('.product-list__slider', {
    slidesPerView: 'auto',
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

function initColorSwatchSlider() {
  try {
    let colors = document.querySelectorAll('.cusSwatchesBody .swatchesPanel-item, .cusSwatchesBody .color-swatch-link');
    if (colors.length <= 6) return;

    const colorSwatchSlider = new Flickity('.cusSwatchesBody .swatchesPanel', {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      watchCSS: true,
      prevNextButtons: false,
      pageDots: false,
    });
  } catch (error) {
    console.error('Error initializing color swatch slider:', error);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const productListSlider = document.querySelector('.product-list__slider');
  if (productListSlider) {
    window.pfLoadSwiper(productListSlider).then(initProductListSlider, () => {});
  }

  if (document.querySelector('.cusSwatchesBody .swatchesPanel')) {
    initColorSwatchSlider();
  }
});

/**
 * Update social proof count on product add to cart
 * @param {Number} productId - Product ID
 */
async function updateSocialCount(productId) {
  try {
    // const token = `Bearer AYvGAAIjcDE1MTJhNThkYTkxOWY0ZWFjOTViMjU0Y2Q2YjY3ZjJmNHAxMA`;
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    // myHeaders.append("Authorization", token);
    myHeaders.append('Type', 'post');

    const raw = JSON.stringify({
      product_id: productId,
      date: new Date(),
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const res = await fetch('https://5dhb8suum8.execute-api.us-east-1.amazonaws.com/prod/pf-social-proof', requestOptions);
    const result = await res.json();

    return result;
  } catch (err) {
    console.log('Set Social Record : ', err);
  }
}

window.updateSocialCount = updateSocialCount;